import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "../../components";
import { BookStore, Dispatcher } from "../../flux";
import { toastUtils } from "../../../../utils/toast-utils";
import { colors } from "chameleonjs";
const gadgetId = "bartleby";

class BartlebyPanel extends React.Component {
  state = {
    loading: true,
    url: false,
    error: false
  };

  componentDidMount() {
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.getUniversalURL(response => {
      const cfi = response.isSuccess()
        ? response.data.url
        : book.viewer.settings.cfi;
      Jigsaw.User.createLTILaunch(
        {
          type: "partner",
          label: "Bartleby",
          partner_id: "bartleby",
          isbn: this.props.isbn,
          context_id: Fraction.Brand.jigsawBrand,
          brand_key: Fraction.Brand.jigsawBrand,
          resource_link_id: cfi
        },
        response => {
          if (response.isSuccess()) {
            this.setState({ loading: false, url: response.data.redirect_url });
          } else {
            this.setState({ loading: false, error: true });
          }
        }
      );
    });
  }

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }
    if (this.state.error) {
      return <span>{i18n.t("messages.500-error")}</span>;
    } else if (this.state.url) {
      return (
        <span>
          <div
            className="hidden-request-accessible-version"
            role="complementary"
          >
            <p tabIndex="-1">{toHTML(i18n.t("bartleby.accessibility"))}</p>
          </div>
          <iframe
            title="Bartleby"
            width="100%"
            height="100%"
            src={this.state.url}
          />
        </span>
      );
    }
  }
}

BartlebyPanel.propTypes = {
  isbn: PropTypes.string.isRequired
};

BartlebyPanel.defaultProps = {};

const openBartlebyPanel = () => {
  Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
};

const isEnabled = () => Fraction.Brand.Bartleby.enabled;

Dispatcher.bind(Dispatcher.BOOK_OPENED, isbn => {
  if (isEnabled()) {
    showBartlebyToast(isbn);
  }
});

function toastOpenBartlebyPanel() {
  Dispatcher.emit(Dispatcher.SHOW_PANEL, gadgetId);
  toastUtils.dismiss("bartleby-toast");
}

function hideBartlebyToast() {
  const bartlebyOnboarding =
    Fraction.Helpers.Users.getUserData("bartlebyOnboardingObject") || {};
  bartlebyOnboarding.hideMessage = true;
  Fraction.Helpers.Users.saveUserData(
    "bartlebyOnboardingObject",
    bartlebyOnboarding
  );
  toastUtils.dismiss("bartleby-toast");
}

function showBartlebyToast(isbn) {
  const book = BookStore.get(isbn);
  const bartlebyOnboardingObject =
    Fraction.Helpers.getUserData("bartlebyOnboardingObject") || {};
  if (!bartlebyOnboardingObject.hideMessage && isEnabled(isbn)) {
    toastUtils.notify({
      id: "bartleby-toast",
      children: (
        <div>
          24/7 homework help is available for this title from bartleby.
          Available now from within your Bookshelf e-reader.
          <button
            className="noButton"
            style={{ fontSize: "14px" }}
            onClick={toastOpenBartlebyPanel}
          >
            {window.toHTML(i18n.t("chegg.click-here-to-open"))}
          </button>
        </div>
      ),
      imageUrl: book.coverURL && book.coverURL.replace(":width", "60"),
      backgroundColor: colors.cloud.getShade(3),
      borderColor: colors[Fraction.Brand.Theme.primary],
      borderPosition: "left",
      maxWidth: 250,
      checkboxText: i18n.t("base.dont-show-again"),
      horizontalPosition: "right",
      dismissible: true,
      onCheckboxChange: hideBartlebyToast
    });
  }
}

module.exports = {
  class: BartlebyPanel,
  metadata: () => ({
    id: gadgetId,
    name: "24/7 Homework Help",
    learnMore: false,
    launch: "// TODO",
    toggle: false,
    expanded: false,
    type: "panel",
    autoShow: false,
    enabled: isEnabled,
    hideInMobile: true,
    sidebar: {
      icon: "/img/bartleby/bartleby_logo.svg",
      activeMethod: "fill", // 'fill' or 'highlight'
      action: openBartlebyPanel,
      toolTip: isbn => "FREE 24/7 Homework Help"
    }
  })
};
